import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../shared/services/auth-guard.service';
import { WelcomeComponent } from './pages/welcome/welcome.component';
import { RedirectPageComponent } from './pages/welcome/redirect-page/redirect-page.component';

const routes: Routes = [
  { path: ':guid', component: WelcomeComponent},
  { path: 'welcome/redirect-page/:guid', component: RedirectPageComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WelcomeRoutingModule { }
